import React, { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingSpinner from '../common/LoadingSpinner';

const RoleBasedRedirect: React.FC = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user && !loading) {
      // Redirect based on user role
      switch (user.role) {
        case 'client':
          navigate('/dashboard/client', { replace: true });
          break;
        case 'developer':
          navigate('/dashboard/developer', { replace: true });
          break;
        case 'admin':
          navigate('/dashboard/admin', { replace: true });
          break;
        default:
          navigate('/dashboard/client', { replace: true });
      }
    }
  }, [user, loading, navigate]);

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // This will only show briefly before the useEffect redirects
  return <LoadingSpinner text="Redirecting to your dashboard..." />;
};

export default RoleBasedRedirect;